import { render, staticRenderFns } from "./loginFrom.vue?vue&type=template&id=5c8cb8c4&scoped=true"
import script from "./loginFrom.vue?vue&type=script&lang=js"
export * from "./loginFrom.vue?vue&type=script&lang=js"
import style0 from "./loginFrom.vue?vue&type=style&index=0&id=5c8cb8c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8cb8c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8cb8c4')) {
      api.createRecord('5c8cb8c4', component.options)
    } else {
      api.reload('5c8cb8c4', component.options)
    }
    module.hot.accept("./loginFrom.vue?vue&type=template&id=5c8cb8c4&scoped=true", function () {
      api.rerender('5c8cb8c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/smsConfig/components/loginFrom.vue"
export default component.exports